<div class="loading-indicator">
  <img class="loader" [hidden]="!isLoading" src="/assets/img/image-loading-white.svg" alt="Loading..." />
</div>